import "../../../css/toggleSwitch.css";

interface ToggleSwitchProps {
  label: string;
  name: string;
  value: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

export const ToggleSwitch = ({
  label,
  name,
  value,
  checked,
  onChange,
  className,
}: ToggleSwitchProps) => {
  return (
    <div className={`text-grey h-full text-md font-thin flex ${className}`}>
      {label} :{" "}
      <div className="toggle-switch ml-2">
        <input
          type="checkbox"
          className={`checkbox `}
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          id={label}
        />
        <label className="label" htmlFor={label}>
          <span className="inner" />
          <span className="switch" />
        </label>
      </div>
    </div>
  );
};
